/**
 * Where a card comes from, as a small icon before its kind label: a book for
 * the team's own documents (scripts/agents/*, node_analysis.provenance.extractor),
 * a bot for the AI on the map, a person for a participant. The node modal says
 * the same in words (impactPath.source.*). Structural cards (mission, town,
 * scenario starter) carry none.
 */
import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { BookOpen, Bot, User } from 'lucide-react';

export const SOURCE_ICON_SIZE = 12;

/** 'documents' | 'ai' | 'human' | null for a structural card. */
export function nodeSource(node) {
  if (!node || node.isRoot || node.type === 'root' || node.is_scenario_starter || node.type === 'scenario_root') return null;
  const a = node.node_analysis || node.nodeAnalysis || {};
  if (a.provenance?.extractor || a.prefilled) return 'documents';
  if (a.provenance?.kind === 'ai' || node.created_by === 'ai' || node.createdBy === 'ai' || node.aiGenerated) return 'ai';
  return 'human';
}

const ICONS = { documents: BookOpen, ai: Bot, human: User };

/** Appends the icon to a d3 group at (x, y), top-left anchored; returns the width it took (0 when none). */
export function appendSourceIcon(group, node, x, y, color) {
  const source = nodeSource(node);
  if (!source) return 0;
  group.append('g')
    .attr('class', `node-source node-source-${source}`)
    .attr('transform', `translate(${x}, ${y})`)
    .attr('pointer-events', 'none')
    .html(renderToStaticMarkup(createElement(ICONS[source], { size: SOURCE_ICON_SIZE, strokeWidth: 2.2, color })));
  return SOURCE_ICON_SIZE + 5;
}
